var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Draw your signature within the box below")]),_c('div',{staticClass:"signature-pad"},[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"width":"100%","height":"300px","options":{onBegin: () => {_vm.$refs.signaturePad.resizeCanvas()}}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }